// src/components/HeroVideo.jsx
import React, { useEffect, useState, Suspense } from "react";
import { motion } from "framer-motion";
import "./HeroVideo.css";

const LazyMuxPlayer = React.lazy(() => import("@mux/mux-player-react"));

export default function HeroVideo() {
  const [animationDone, setAnimationDone] = useState(false);
  const [isClient, setIsClient] = useState(false); // ✅ Prevent SSR/render crash

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div>
    </div>
  );
}
